import { render, staticRenderFns } from "./CardBugReport.vue?vue&type=template&id=b8ca0b32&scoped=true&"
import script from "./CardBugReport.vue?vue&type=script&lang=js&"
export * from "./CardBugReport.vue?vue&type=script&lang=js&"
import style0 from "./CardBugReport.vue?vue&type=style&index=0&id=b8ca0b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ca0b32",
  null
  
)

export default component.exports